module.exports = __webpack_public_path__ + "shot_trainer.png?f82ba1541583f753a51482099f1a6712";